import * as React from "react";


import "./AdminOffer.scss";
import {Box, Card, IconButton} from "@mui/material";

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import {checkUserAllowed, getImage, getLocalDate} from "helpers/utils";
import {DATE_TIME_FORMAT_SHORT} from "config/constants";
import {H2, H5} from "components/CustomTypography";
import ViewListIcon from "@mui/icons-material/ViewList";


const AdminSupportTicket = (props) => {
  const { saleslog = {}, userDetails, editProducts, editCategorySettings, className = "" } = props;
  const { id, name, images = [], is_popular, is_active, store_entry } = saleslog;

  return (
      <Box sx={{backgroundColor : "#eee"}} width="100%" mt={2} p={1} display="flex">
          <Box width="80%" order={1} onClick={editCategorySettings}>
          <H2 textTransform="uppercase" mb={2} fontSize={16} textAlign="left" title={saleslog.shop && saleslog.shop.title} ellipsis>
              {saleslog.shop && saleslog.shop.title}
          </H2>
              <H5 fontSize={12} mb={1} textAlign="left" title={saleslog.name} ellipsis>
                  {saleslog.type} ({saleslog.status})
              </H5>
          <H5 fontSize={12} mb={1} textAlign="left" title={saleslog.name} ellipsis>
              {saleslog.message}
          </H5>
          <H5 fontSize={12} mb={1} textAlign="left" ellipsis>
             {getLocalDate(saleslog.created_at, DATE_TIME_FORMAT_SHORT)}
          </H5>
          </Box>
          <Box width="20%" order={2} display="flex">
              {checkUserAllowed(userDetails.userlevel, "products") &&
                  <IconButton color="primary" size="small" onClick={editProducts}>
                      <ViewListIcon/>
                  </IconButton>
              }
              <IconButton className="setting-button" color="primary" size="small" onClick={editCategorySettings}>
                  <MoreHorizIcon />
              </IconButton>
          </Box>
      </Box>
  );
};

export default AdminSupportTicket;
